<template>
    <div class="logo-thumbnail logo-custom-css" style="width: 184px;">
        <router-link class="logo-light" to="/">
            <img style="width: 160px;" :src="require(`@/assets/images/logo/logo-white.png`)" alt="nft-logo">
        </router-link>
        <router-link class="logo-dark" to="/">
            <img style="width: 160px;" :src="require(`@/assets/images/logo/logo-dark.png`)" alt="nft-logo">
        </router-link>
    </div>
</template>

<script>

    export default {
        name: 'Logo'
    }
</script>